import { render, staticRenderFns } from "./BackerCenterUpdateFeedEmptyState.vue?vue&type=template&id=eb34d40e"
import script from "./BackerCenterUpdateFeedEmptyState.vue?vue&type=script&lang=js"
export * from "./BackerCenterUpdateFeedEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports